import ApiService from "../api/ApiService";

class SupportService {
    getCustomerCare() {
        return ApiService.get("/CustomerCare");
    }
}

export default new SupportService();